import { useEffect } from 'react';
import { useStore } from './store';
import { dismissToast, toastStore } from './toast';

/** Long enough to reach Undo with one thumb. */
const VISIBLE_MS = 6000;

export function ToastHost() {
  const toast = useStore(toastStore);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(dismissToast, VISIBLE_MS);
    return () => clearTimeout(t);
  }, [toast]);

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-4 bottom-[calc(140px+env(safe-area-inset-bottom))] z-40 mx-auto max-w-lg lg:bottom-24 lg:left-[calc(15rem+16px)]"
    >
      {toast ? (
        <div
          key={toast.id}
          data-testid="toast"
          className="pointer-events-auto flex items-center justify-between gap-3 rounded-[14px] border border-border bg-surface-2 px-3 py-2 text-sm text-fg"
        >
          <span>{toast.message}</span>
          {toast.action ? (
            <button
              type="button"
              className="min-h-11 rounded-full px-3 font-medium text-accent-text"
              onClick={() => {
                toast.action?.onPress();
                dismissToast();
              }}
            >
              {toast.action.label}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
